import type { ReactNode } from "react";

import { SkyAgentNav } from "./SkyAgentNav";

interface DashboardLayoutProps {
  children: ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <div className="flex min-h-screen bg-surface-page text-fg-primary">
      {/* SkyAgent left-hand menu (renders only in skyagent mode; null otherwise,
          so the dashboard shows full-width everywhere else). */}
      <SkyAgentNav />
      <div className="flex min-w-0 flex-1 flex-col gap-4 px-[4vw] py-6">{children}</div>
    </div>
  );
}
